import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import { WhatIsSection, BenefitsSection, ComparisonSection, BlogSection, TrustSection, CtaSection, FaqSection } from "./components/ContentSections";

const siteUrl = "https://sugargoosheet.casa";

export default function Home() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Sugargoo Spreadsheet",
    url: siteUrl,
    description: "The largest English resource hub for Sugargoo Spreadsheet, product research, and China sourcing strategies.",
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is Sugargoo Spreadsheet?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Sugargoo Spreadsheet is a structured product research document that organizes product listings, supplier information, pricing data, and shipping estimates from Chinese e-commerce platforms. It helps dropshippers, resellers, and individual buyers streamline their product sourcing workflow by providing pre-organized data in a ready-to-use format.",
        },
      },
      {
        "@type": "Question",
        name: "Is Sugargoo Spreadsheet suitable for beginners?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Absolutely. The Sugargoo Spreadsheet is designed to be beginner-friendly with a copy-paste ready format. Even if you have never sourced products from China before, the organized structure makes it easy to find products, compare prices, and understand supplier ratings without any prior experience.",
        },
      },
      {
        "@type": "Question",
        name: "How often is Sugargoo Spreadsheet updated?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "The spreadsheet is regularly updated to reflect the latest trending products, current pricing, and active supplier information. Product lists are refreshed to ensure you always have access to relevant and profitable items for your business.",
        },
      },
      {
        "@type": "Question",
        name: "Can I use Sugargoo Spreadsheet for dropshipping?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, the Sugargoo Spreadsheet is particularly valuable for dropshippers. It provides organized product data that helps you quickly identify winning products, compare supplier pricing, and make informed sourcing decisions — significantly reducing the time spent on manual product research.",
        },
      },
      {
        "@type": "Question",
        name: "What platforms are covered in Sugargoo Spreadsheet?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "The spreadsheet primarily covers products from major Chinese e-commerce platforms including Taobao, 1688, and Weidian. It also includes supplier ratings, shipping options, and pricing comparisons to help you make the best sourcing decisions.",
        },
      },
    ],
  };

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Sugargoo Spreadsheet",
    url: siteUrl,
    description: "The largest English resource hub for Sugargoo Spreadsheet — discover product lists, shipping guides, reviews, coupons and China sourcing strategies.",
    inLanguage: "en",
    publisher: {
      "@type": "Organization",
      name: "Sugargoo Spreadsheet",
      url: siteUrl,
    },
  };

  return (
    <>
      <JsonLd data={orgSchema} />
      <JsonLd data={webSiteSchema} />
      <JsonLd data={faqSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <WhatIsSection />
        <BenefitsSection />
        <ComparisonSection />
        <BlogSection />
        <TrustSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}